import service, {API} from 'fetch/service';

import type {Page, ResponseList} from '../interface';
import {ICommentItem, ReplayItem, Item} from './interface';

export type {
  ICommentItem,
  ReplayItem,
  Item
}

/**
 * 评论的增删改查
 */
export const COMMENT = {
  post(data: {content: string, id: string}) {
    return service.post(API.works.comment, data)
  },
  get(data: {id: string} & Page) {
    return service.get(API.works.commentList, {
      params: data
    })
    .then((res: any) => {
      return {
        dataList: res.dataList || [],
        totalCount: res.totalCount
      } as ResponseList<ICommentItem>
    })
  },
  del(commentId: number) {
    return service.post(API.works.commentDel, {} , {
      params: {commentId}
    })
  },
  like(commentId: number) {
    return service.post(API.works.commentLike, {} , {
      params: {commentId}
    })
  },
  unlike(commentId: number) {
    return service.post(API.works.commentUnLike, {} , {
      params: {commentId}
    })
  }
}
export interface ReplayPostParams {
  content: string, commentId: number, replyId?: number
}

/**
 * 回复、回复的回复的增删改查
 */
export const REPLAY = {
  post(data: ReplayPostParams) {
    return service.post(API.works.reply, data)
  },
  get(data: {commentId: number}  & Page) {
    return service.get(API.works.replyList, {
      params: data
    })
    .then((res: any) => {
      return {
        dataList: res.dataList || [],
        totalCount: res.totalCount
      } as ResponseList<ReplayItem>
    })
  },
  del(replyId: number) {
    return service.post(API.works.replyDel, {} , {
      params: {replyId}
    })
  },
  like(replyId: number) {
    return service.post(API.works.replyLike, {} , {
      params: {replyId}
    })
  },
  unlike(replyId: number) {
    return service.post(API.works.replyUnLike, {} , {
      params: {replyId}
    })
  }
}
